var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D92D20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_17101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.332 14.3809L32.6654 32.7142",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.332 14.3809L32.6654 32.7142",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 21.3295V16.8795C26.0006 16.2595 25.7709 15.6614 25.3553 15.2013C24.9398 14.7412 24.3681 14.4519 23.7512 14.3896C23.1344 14.3273 22.5164 14.4964 22.0173 14.8641C21.5181 15.2318 21.1734 15.7719 21.05 16.3795M21 21.0461V23.5461C21.0004 24.0403 21.1473 24.5232 21.422 24.9339C21.6968 25.3446 22.087 25.6647 22.5436 25.8538C23.0001 26.0428 23.5025 26.0923 23.9871 25.996C24.4718 25.8997 24.917 25.662 25.2667 25.3128L21 21.0461Z",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 21.3295V16.8795C26.0006 16.2595 25.7709 15.6614 25.3553 15.2013C24.9398 14.7412 24.3681 14.4519 23.7512 14.3896C23.1344 14.3273 22.5164 14.4964 22.0173 14.8641C21.5181 15.2318 21.1734 15.7719 21.05 16.3795M21 21.0461V23.5461C21.0004 24.0403 21.1473 24.5232 21.422 24.9339C21.6968 25.3446 22.087 25.6647 22.5436 25.8538C23.0001 26.0428 23.5025 26.0923 23.9871 25.996C24.4718 25.8997 24.917 25.662 25.2667 25.3128L21 21.0461Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6642 27.6725C26.8507 28.5029 25.8077 29.0712 24.6689 29.3047C23.5301 29.5381 22.3476 29.426 21.273 28.9828C20.1984 28.5395 19.2807 27.7852 18.6377 26.8168C17.9947 25.8484 17.6557 24.7099 17.6642 23.5475V21.8809M29.3309 21.8809V23.5475C29.3306 23.8912 29.2999 24.2342 29.2392 24.5725",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6642 27.6725C26.8507 28.5029 25.8077 29.0712 24.6689 29.3047C23.5301 29.5381 22.3476 29.426 21.273 28.9828C20.1984 28.5395 19.2807 27.7852 18.6377 26.8168C17.9947 25.8484 17.6557 24.7099 17.6642 23.5475V21.8809M29.3309 21.8809V23.5475C29.3306 23.8912 29.2999 24.2342 29.2392 24.5725",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.3809V32.7142",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.3809V32.7142",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.168 32.7129H26.8346",
    stroke: "black",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.168 32.7129H26.8346",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_17101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.7e61f8c0f5e025bbc353216e25ffe427.svg";
export { ForwardRef as ReactComponent };